import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { database } from "../firebase";
import { useDispatch, useSelector } from "react-redux";
import ConnectRequest from "./ConnectRequest";

function AsideContacts() {
    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
    }));
const [friends,setFriends]=useState([])
    function getUserData(uid) {
        return new Promise((resolve, reject) => {
            return database.ref("users/" + uid).once("value", (snap) => {
                resolve(snap.val());
            });
        });
    }
    function getFriends() {
        return database
            .ref(`/connectuser/${currentUser.uid}`)
            .orderByChild("status")
            .equalTo("Accepted")
            .once("value")
            .then(async (snapshot) => {

                const array = [];
                snapshot.forEach((childSnapshot) => {
                    array.push(childSnapshot.key);
                });

                const results = await Promise.all(
                    array.map(async (uid, i) => {
                        const data = await getUserData(uid);
                        return { uid, user_details: data }
                    })
                );
                setFriends(results)
            }
        )
    }

    useEffect(() => {
        getFriends();
    }, [])

    return (
        <>
            <aside className="right-aside" id="rightaside">
                <div className="card border-0 rounded-xl shadow-xs mb-3">
                    <div className="card-body p-4">
                        <h5 className="fw-bold fs-12 text-uppercase text-lightgrey mb-3">Contacts</h5>
                        <ul className="aside-contactlist">
                            {
                                friends.map((contact) =>
                                <li className="py-2" key={contact.uid}>
                                        <Link to={`/Messages/${contact.uid}`} className="fs-13 text-muted fw-bold" data-status={contact.user_details?.ActiveStatus}>
                                            <img src={contact.user_details?.profileImageUrl} alt="user" />
                                            <span>@{contact.user_details?.fullName}</span>
                                        </Link>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
                <ConnectRequest></ConnectRequest>
            </aside>
        </>
    );
}
export default AsideContacts;